<div class="modal-header"><h2 class="modal-title">Accounts</h2></div>
<div class="modal-body">
  @if (account) {
    <div>
      <dx-form [formData]="account" validationGroup="statusChangeData" [colCount]="2">
        <!-- <dxi-item dataField="id" [disabled]="true" [colSpan]="2"></dxi-item> -->
        <dxi-item dataField="name" [colSpan]="2" [disabled]="!canEdit" ></dxi-item>
        @if (appInfo.graafschap) {
          <dxi-item dataField="quickBooksAccount" [disabled]="!canEdit" ></dxi-item>
        }
        @if (appInfo.graafschap) {
          <dxi-item dataField="classisAccount" [disabled]="!canEdit" ></dxi-item>
        }
        <dxi-item dataField="displayOrder"></dxi-item>
        <dxi-item itemType="empty"></dxi-item>
        <dxi-item dataField="alwaysInclude"></dxi-item>
        <dxi-item dataField="active"></dxi-item>
        <dxi-item dataField="website" [colSpan]="2"></dxi-item>
        @if (account) {
          <dxi-item [label]="{ text: 'Notes' }" [colSpan]="2">
            <div *dxTemplate>
              <dx-text-area [(value)]="account.notes" [height]="100"> </dx-text-area>
            </div>
          </dxi-item>
        }
        <dxi-item>
          @if (attachments) {
            <ul style="list-style-type: none; padding-inline-start: 0px">
              @for (attachment of attachments; track attachment) {
                <li>
                  <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                  <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                </li>
              }
            </ul>
          }
        </dxi-item>
      </dx-form>
      @if (true) {
        <div class="d-flex">
          <dx-file-uploader
            name="fileUpload"
            selectButtonText="Select File(s)"
            class="attachments hide-on-phone"
            accept="*"
            uploadMode="instantly"
            [showFileList]="false"
            [multiple]="true"
            [uploadUrl]="serviceName + '/api/utility/uploadContributionAccountAttachment/'"
            (onUploadStarted)="uploadStarted($event)"
            (onUploadError)="uploadError($event)"
            (onUploaded)="uploaded($event)"
            [uploadHeaders]="uploadHeaders"
            >
          </dx-file-uploader>
        </div>
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="save()">Save</button>
  <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
